<template>
  <div>
    <div class="md-layout">
      <div class="md-layout-item md-size-40">
        <shop-grid-selector></shop-grid-selector>
        <md-field slot="inputs" class="mt-4 form-group label-floating md-size-50">
          <md-input v-model="skuFilter" type="text" class="form-control" name="skuFilter"></md-input>
          <label for="skuFilter" class="control-label">{{ $t('pages.shipments.skuFilterLabel') }}</label>
        </md-field>
        {{ $t("pages.shipments.standardOrders") }}:
        <md-checkbox v-model="onlyStandardOrders"></md-checkbox>
        {{ $t("pages.shipments.specialOrders") }}:
        <md-checkbox v-model="onlySpecialOrders"></md-checkbox>
        <md-button class="md-raised" v-on:click="openProductCountModal()">
          {{ $t("pages.shipments.productCountBtn") }}
        </md-button>
        <br />
        {{ $t("pages.shipments.evenOrders") }}:
        <md-checkbox v-model="onlyEvenOrders"></md-checkbox>
        {{ $t("pages.shipments.oddOrders") }}:
        <md-checkbox v-model="onlyOddOrders"></md-checkbox>
        <br />
        {{ $t("pages.shipments.thisWeek") }}:
        <md-checkbox v-model="onlyThisWeek"></md-checkbox>

        <md-table v-model="sortedOrders" md-card md-fixed-header>
          {{ $t("pages.shipments.orderstoday") }}:{{ ordersToday.length }}
          {{ $t("pages.shipments.orderstotal") }}:{{ orders.length }}
          <md-table-toolbar>
            <h4 class="title">
              {{ $t("pages.shipments.orderstoday") }}:{{ ordersToday.length }}
              {{ $t("pages.shipments.orderstotal") }}:{{ orders.length }}
              <b
                v-if="onlyStandardOrders || onlySpecialOrders || onlyEvenOrders || onlyOddOrders || skuFilter || onlyThisWeek">{{
                  $t("pages.shipments.ordersactivetotal") }}:{{ allActiveOrders.length }}</b>
            </h4>
          </md-table-toolbar>
          <md-table-row slot="md-table-row" :class="getRowClass(item)" v-on:click="setActiveOrder(item)"
            slot-scope="{ item }">
            <md-table-cell :md-label="$t('pages.shipments.order')">
              <div :id="'order_' + item.mys_extordernumber">
                {{ item.mys_extordernumber }}
              </div>
            </md-table-cell>
            <md-table-cell :md-label="$t('pages.shipments.customer')">
              <div>{{ item.billto_name }}</div>
            </md-table-cell>

            <md-table-cell :md-label="$t('pages.shipments.senddate')">
              <template v-if="item.mys_date_est_send">
                {{ m(item.mys_date_est_send).format("DD-MM-YY") }}
              </template>
            </md-table-cell>
            <md-table-cell :md-label="$t('pages.shipments.date')">
              <template v-if="item.mys_date">
                {{ m(item.mys_date).format("DD-MM-YY") }}
              </template>
            </md-table-cell>
          </md-table-row>
        </md-table>
      </div>
      <div class="md-layout-item md-size-60">

        <order-view v-if="activeOrder" :activeOrder="activeOrder" ref="orderView" @order-completed="onOrderCompleted"></order-view>
      </div>
    </div>
  </div>
</template>
<script>
import { ChartCard, AnimatedNumber } from "@/components";

import apiService from "../../../services/APIService";
import moment from "moment";
import { mapGetters } from "vuex";
import $ from "jquery";
import OrderView from "./Components/OrderView";
import _ from "lodash";
import Swal from "sweetalert2";
import keyboardBufferMixin from "@/Mixins/keyboardBufferMixin";
import ShopGridSelector from "@/pages/Dashboard/Shipping/Components/ShopGridSelector";
import store from "@/store";

export default {
  mixins: [keyboardBufferMixin],
  data() {
    return {
      skuFilter: "",
      onlyStandardOrders: false,
      onlySpecialOrders: false,
      onlyEvenOrders: false,
      onlyOddOrders: false,
      onlyThisWeek: true,
      showChart: false,
      m: moment,
      activeOrderId: null,
      suppressRemovalFor: null,
      advanceToOrderId: null,
      dailySalesChart: {},
      debounceTimeout: null,
      updateInProgress: false,
    };
  },
  components: {
    ShopGridSelector,
    OrderView,
    ChartCard,
    AnimatedNumber
  },
  computed: {
    allActiveOrders() {
      return this.warehouseShipments.filter((o) => o.statecode === 0 && o._mys_OwningAccount_value === this.activeAccount.mys_account);
    },
    ordersToday() {
      var ordersToday = this.orders.filter((o) => !o.mys_date_est_send || moment(o.mys_date_est_send).isBefore(moment()));
      return ordersToday;
    },
    orders() {
      var filteredOrders = this.allActiveOrders;

      if (this.onlyStandardOrders) {
        filteredOrders = filteredOrders.filter(o =>
          o.orderProducts.every(op =>
            op.mys_extsku.startsWith("M-") || op.mys_extsku === "FPK" || op.mys_extsku === "AKT"
          )
        );
      } else if (this.onlySpecialOrders) {
        filteredOrders = filteredOrders.filter(o =>
          o.orderProducts.some(op =>
            !op.mys_extsku.startsWith("M-") && op.mys_extsku !== "FPK" && op.mys_extsku !== "AKT"
          )
        );
      }

      if (this.onlyEvenOrders) {
        filteredOrders = filteredOrders.filter(o => o.mys_extordernumber % 2 === 0);
      } else if (this.onlyOddOrders) {
        filteredOrders = filteredOrders.filter(o => o.mys_extordernumber % 2 !== 0);
      }

      if (this.skuFilter) {
        const includeSkus = this.skuFilter.toUpperCase().split(',').filter(s => !s.startsWith('!')).map(s => s.trim());
        const excludeSkus = this.skuFilter.toUpperCase().split(',').filter(s => s.startsWith('!')).map(s => s.substring(1).trim());

        filteredOrders = filteredOrders.filter(order => {
          const orderSkus = order.orderProducts.map(op => op.mys_extsku.toUpperCase());

          // Check for inclusion
          const includesCondition = includeSkus.length === 0 || orderSkus.some(orderSku => includeSkus.some(includeSku => orderSku.startsWith(includeSku)));

          // Check for exclusion
          const excludesCondition = !excludeSkus.some(excludeSku => orderSkus.some(orderSku => orderSku.startsWith(excludeSku)));

          return includesCondition && excludesCondition;
        });
      }

      if (this.onlyThisWeek) {
        const now = new Date();
        // Calculate the last day (Sunday) of the week
        const lastDayOfWeek = new Date(now.setDate(now.getDate() - now.getDay() + 7));
        // Reset hours for the end of the day
        lastDayOfWeek.setHours(23, 59, 59, 999);

        filteredOrders = filteredOrders.filter(order => {
          // Assuming order.date is in a format that can be directly compared to JavaScript Date objects
          // If not, you may need to parse it into a Date object first
          const orderDate = new Date(order.mys_date_est_send);
          return orderDate <= lastDayOfWeek;
        });
      }

      filteredOrders.forEach(order => {
        const products = order.orderProducts;
        const updatedProducts = [];
        let targetProduct = null;

        products.forEach(product => {
          if (product.mys_extsku.startsWith("M-")) {
            if (!targetProduct) {
              // The first "M-" product becomes the target product
              targetProduct = product;
              updatedProducts.push(targetProduct);
            } else {
              // Merge quantities into the target product
              targetProduct.quantity =
                (parseInt(targetProduct.quantity, 10) || 0) +
                (parseInt(product.quantity, 10) || 0);
            }
          } else {
            // Add non-"M-" products to the updated list
            updatedProducts.push(product);
          }
        });

        console.log("filter loop hit!")
        console.log(updatedProducts)

        // Replace the order's orderProducts with the updated list
        order.orderProducts = updatedProducts;
      });

      return filteredOrders;


    },
    ...mapGetters(["activeAccount", "warehouseShipments", "activeWarehouseId", "shops", "activeWarehousePrinterId"]),
    activeOrder() {
      // Sticky: resolve the selected order by its stable id so it survives list
      // reloads/re-sorts. Falls back to the top order when nothing is selected (or
      // the selection was removed).
      if (this.activeOrderId) {
        const sticky = this.sortedOrders.find(o => o.salesorderid === this.activeOrderId);
        if (sticky) return sticky;
      }
      return this.sortedOrders[0];
    },
    sortedOrders() {
      return this.orders.sort((a, b) => {
        if (!a.mys_date_est_send) return -1;

        if (moment(a.mys_date_est_send) < moment(b.mys_date_est_send))
          return -1;
        else if (moment(a.mys_date_est_send) > moment(b.mys_date_est_send))
          return 1

        let nameA = a.billto_name.toUpperCase()
        let nameB = b.billto_name.toUpperCase()

        if (nameA > nameB)
          return -1
        else if (nameA < nameB)
          return 1

        if (a.mys_extordernumber > b.mys_extordernumber) {
          return -1
        } else if (a.mys_extordernumber == b.mys_extordernumber) {
          return 0
        }
      });
    },


  },
  created() {
    this.init();
    document.addEventListener("keyup", this.keyPress);
  },
  watch: {
    sortedOrders(value) {
      //this.orderIndex = this.orderIndex + 1;
      //this.orderIndex = this.orderIndex - 1;
    },
    orderChartData(value) {
      if (value.labels.length > 0) {
        this.showChart = true;
      }
    },
    activeWarehouseId() {
      // Different warehouse = different list; drop the sticky selection without warning.
      this.activeOrderId = null;
      this.init();
    },
    warehouseShipments(newValue, oldValue) {
      // Only runs when the order data actually reloads (not on filter changes).
      if (!this.activeOrderId) return;

      const stillPresent = this.allActiveOrders.some(o => o.salesorderid === this.activeOrderId);
      if (stillPresent) return;

      // The stickied order is gone after this reload.
      const removedId = this.activeOrderId;

      if (removedId === this.suppressRemovalFor) {
        // The worker completed it themselves; advance to the next order in the list
        // instead of jumping back to the top. The success dialog already covered it.
        this.suppressRemovalFor = null;
        this.activeOrderId = this.advanceToOrderId; // null falls back to the top order
        this.advanceToOrderId = null;
        return;
      }

      this.activeOrderId = null; // jump back to the top order

      const removed = (oldValue || []).find(o => o.salesorderid === removedId);
      const orderNumber = removed ? removed.mys_extordernumber : "";
      // Defer so this doesn't collide with the loading dialog that init() closes.
      setTimeout(() => {
        Swal.fire({
          title: "Ordren er ikke længere på listen",
          html: `Ordre <b>${orderNumber}</b> blev fjernet under en opdatering (muligvis gennemført eller annulleret et andet sted).<br/><br/>Du er flyttet til den øverste ordre — tjek inden du fortsætter.`,
          icon: "warning",
          confirmButtonText: "OK",
        });
      }, 0);
    },
    activeOrder(order) {

      if (!order)
        return;

      var elm = document.getElementById(`order_${order.mys_extordernumber}`);

    },
    onlyStandardOrders(newValue, oldValue) {
      if (newValue != oldValue && !this.updateInProgress) {
        this.updateInProgress = true;
        this.onlySpecialOrders = false;
        this.debounceInit();
      }
      if (newValue === true) {
        this.onlySpecialOrders = false;
      }
    },

    onlySpecialOrders(newValue, oldValue) {
      if (newValue != oldValue && !this.updateInProgress) {
        this.updateInProgress = true;
        this.onlyStandardOrders = false;
        this.debounceInit();
      }
      if (newValue === true) {
        this.onlyStandardOrders = false;
      }
    },

    onlyEvenOrders(newValue, oldValue) {
      if (newValue != oldValue && !this.updateInProgress) {
        this.updateInProgress = true;
        this.onlyOddOrders = false;
        this.debounceInit();
      }
      if (newValue === true) {
        this.onlyOddOrders = false;
      }
    },

    onlyOddOrders(newValue, oldValue) {
      if (newValue != oldValue && !this.updateInProgress) {
        this.updateInProgress = true;
        this.onlyEvenOrders = false;
        this.debounceInit();
      }
      if (newValue === true) {
        this.onlyEvenOrders = false;
      }
    },
    onlyThisWeek(newValue, oldValue) {
      if (newValue != oldValue) {
        this.debounceInit()
      }
    },
    skuFilter(newValue, oldValue) {
      if (this.debounceTimeout) {
        clearTimeout(this.debounceTimeout);
      }

      this.debounceTimeout = setTimeout(() => {
        if (newValue !== oldValue) {
          this.init();
        }
      }, 500);
    }
  },
  methods: {
    openProductCountModal() {
      const summary = this.orders.reduce((acc, order) => {
        order.orderProducts.forEach(product => {
          if (!acc[product.mys_extsku]) {
            acc[product.mys_extsku] = 0;
          }
          acc[product.mys_extsku] += parseInt(product.quantity, 10);
        });
        return acc;
      }, {});


      const summaryHtml = Object.entries(summary)
        .filter(([mys_extsku, quantity]) => quantity > 0)
        .sort((a, b) => a[0].localeCompare(b[0]))
        .map(([mys_extsku, quantity]) => (
          `<div>${mys_extsku}: ${quantity}</div>`
        )).join('<br/>');

      Swal.fire({
        title: this.$t("components.orderview.dialogs.inventoryListing.title"),
        html: summaryHtml
      });
    },
    keyPress() {

      if ([32, 40, 38].indexOf(event.keyCode) === -1) {
        return;
      }

      event.returnValue = false;
      event.preventDefault();

      switch (event.keyCode) {
        case 38: {
          //arrow up
          this.movePrevOrder();
          break;
        }
        case 40: {
          //arrow down
          this.moveNextOrder();
          break;
        }
        case 32: {

          this.$refs.orderView.openOrder();
          break;
        }
      }
    },

    activeIndex() {
      if (!this.activeOrderId) return this.sortedOrders.length > 0 ? 0 : -1;
      return this.sortedOrders.findIndex(o => o.salesorderid === this.activeOrderId);
    },
    movePrevOrder() {
      const i = this.activeIndex();
      if (i <= 0) return;
      this.activeOrderId = this.sortedOrders[i - 1].salesorderid;
    },
    moveNextOrder() {
      const i = this.activeIndex();
      if (i === -1) {
        if (this.sortedOrders.length > 0) this.activeOrderId = this.sortedOrders[0].salesorderid;
        return;
      }
      if (i >= this.sortedOrders.length - 1) return;
      this.activeOrderId = this.sortedOrders[i + 1].salesorderid;
    },
    setActiveOrder(order) {
      this.activeOrderId = order.salesorderid;
    },
    onOrderCompleted(salesorderid) {
      // Worker completed this order; suppress the "removed" warning when it drops off the list.
      this.suppressRemovalFor = salesorderid;

      // Remember the following order now, while the completed one is still in the list,
      // so we can advance to it (instead of jumping to the top) once the list reloads.
      const i = this.sortedOrders.findIndex(o => o.salesorderid === salesorderid);
      if (i !== -1) {
        // Next order down the list, or the previous one if the last order was completed.
        const next = this.sortedOrders[i + 1] || this.sortedOrders[i - 1];
        this.advanceToOrderId = next ? next.salesorderid : null;
      } else {
        this.advanceToOrderId = null;
      }
    },
    getRowClass(order) {
      if (order.parent)
        return "table-warning"
      else if (order === this.activeOrder)
        return "table-info";
      else return "";
    },
    debounceInit() {
      clearTimeout(this.debounceTimer);
      this.debounceTimer = setTimeout(() => {
        this.init().finally(() => {
          this.updateInProgress = false;
        });
      }, 3000);
    },
    init() {
      return new Promise((resolve, reject) => {
        this.showChart = false;

        if (!this.activeAccount || !this.activeWarehouseId) {
          resolve();
          if (!this.user.roles || this.user.roles.length === 0) {
            this.$router.push({ path: "/orders/myorders" });
          } else {
            store.commit("SET_ACCOUNT", this.user.roles[0]);
            init()
          }
          return;
        }

        Swal.fire({
          title: this.$t("components.orderview.dialogs.loading.title"),
          html: this.$t("components.orderview.dialogs.loading.message"),
          onBeforeOpen: () => {
            Swal.showLoading();
          },
          onClose: () => {
            resolve();
          },
        });

        store.dispatch("loadWarehouseShipments").then(() => {
          Swal.close();
          resolve();
        }).catch((error) => {
          console.error("Failed to load warehouse shipments:", error);
          Swal.close();
          reject(error);
        });
      });
    },
  },
};
</script>
<style>
.md-table-cell {
  vertical-align: top;
}

.md-table-cell-container .md-button {
  height: auto;
  width: 170px;
}

.boldfont {
  font-weight: bold;
}

.ct-label {
  color: black !important;
}

.ct-bar {
  stroke: black !important;
}

.ct-grid {
  stroke: rgba(0, 0, 0, 0.2) !important;
}
</style>
